// Detect a real mobile *phone* (not tablet, not desktop).
// Phones get the dedicated mobile login + are routed to the /nova-mobile upload page.
// Tablets (iPad / Android tablets) and computers keep the full platform.
export function isMobilePhone() {
  if (typeof navigator === 'undefined') return false;
  const ua = navigator.userAgent || navigator.vendor || '';

  // iPhone / iPod (iPad is intentionally excluded — it's a tablet)
  if (/iPhone|iPod/i.test(ua)) return true;
  // Windows phones / legacy mobile
  if (/Windows Phone|IEMobile|BlackBerry|webOS|Opera Mini/i.test(ua)) return true;
  // Android phones include "Mobile" in the UA; Android tablets do not
  if (/Android/i.test(ua) && /Mobile/i.test(ua)) return true;

  return false;
}
